const {
  iterableCurry
} = require('../../internal/iterable.js');

const {
  GroupsIterator
} = require('../../internal/groups-iterator.js');

const {
  __map
} = require('../$map/map.js');

const {
  __wrap
} = require('../$wrap/wrap.js');

function __spliterateGrouped(source, strategy, options = {}) {
  return new GroupsIterator(source, strategy, options);
}

exports.__spliterateGrouped = __spliterateGrouped;
const spliterateGrouped = /*#__PURE__*/iterableCurry(function $spliterateGrouped(...args) {
  return __map(__spliterateGrouped(...args), __wrap);
}, {
  minArgs: 1,
  maxArgs: 2,
  growRight: true
});
exports.spliterateGrouped = spliterateGrouped;